import { ChevronRight, LogOut } from 'lucide-react';
import { Link, useNavigate } from 'react-router';
import { CONFIG_NAV, SIDEBAR_NAV, visibleFor } from '@/components/layout/nav';
import { PageHeader } from '@/components/PageHeader';
import { useAuth } from '@/lib/auth';
import { useCurrentLocal } from '@/lib/local-context';

/** Pestaña "Más" de la bottom tab bar (mobile): todo lo que no entra en las 3 pestañas principales. */
export function MasPage() {
  const local = useCurrentLocal();
  const { logout, user } = useAuth();
  const navigate = useNavigate();
  const inTabs = new Set(['caja', 'menu', 'estadisticas', 'configuracion']);
  const sections = [
    { title: 'General', items: SIDEBAR_NAV.filter((i) => !inTabs.has(i.to)).filter(visibleFor(local.role)) },
    { title: 'Configuración', items: CONFIG_NAV.filter(visibleFor(local.role)) },
  ];

  return (
    <div>
      <PageHeader title="Más" />
      <div className="grid gap-6">
        {sections.map((s) => (
          <section key={s.title}>
            <h2 className="mb-2 text-xs font-semibold tracking-wide text-muted-foreground uppercase">{s.title}</h2>
            <ul className="divide-y overflow-hidden rounded-xl border bg-card">
              {s.items.map((item) => (
                <li key={item.to}>
                  <Link to={`/l/${local.id}/${item.to}`} className="flex items-center gap-3 px-4 py-3.5 text-sm hover:bg-accent">
                    <item.icon className="size-5 text-muted-foreground" />
                    <span className="flex-1">{item.label}</span>
                    <ChevronRight className="size-4 text-muted-foreground" />
                  </Link>
                </li>
              ))}
            </ul>
          </section>
        ))}
        <button
          type="button"
          onClick={() => {
            logout();
            navigate('/login', { replace: true });
          }}
          className="flex items-center gap-3 rounded-xl border bg-card px-4 py-3.5 text-sm text-destructive hover:bg-accent"
        >
          <LogOut className="size-5" /> {user?.isDemo ? 'Salir de la demo' : 'Cerrar sesión'}
        </button>
      </div>
    </div>
  );
}
